import { useTripTaskStore } from 'shared/stores';
import { ETripTaskType } from 'types/trips';
import { CustomsTaskForm } from './customs-task-form';
import { LocationTaskForm } from './location-task-form';
import { ReloadingFromTaskForm } from './reloading-from-task-form';
import { WarehouseTaskForm } from './warehouse-task-form';

export const TaskDetails = () => {
  const { taskType } = useTripTaskStore();

  if (taskType === ETripTaskType.customs) {
    return <CustomsTaskForm />;
  }

  if (
    taskType === ETripTaskType.loading ||
    taskType === ETripTaskType.unloading ||
    taskType === ETripTaskType.reloading_to ||
    taskType === ETripTaskType.return_asset ||
    taskType === ETripTaskType.trailer_swap
  ) {
    return <LocationTaskForm />;
  }

  if (taskType === ETripTaskType.loading_wh || taskType === ETripTaskType.unloading_wh) {
    return <WarehouseTaskForm />;
  }

  if (taskType === ETripTaskType.reloading_from) {
    return <ReloadingFromTaskForm />;
  }

  return null;
};
